import { Col } from "react-bootstrap";
import { MeasurementValue } from "../../../../api/rtk/weatherStations/slices/weatherStationsApiSlice";
import { WEATHER_CONDITIONS } from "../../hourMeasurementList/HourMeasurementItem";
import { getWindDirectionByAngle, windDirectionIconSrc } from "./specificFields/windDirection";
import { ROAD_STATUSES } from "./specificFields/roadStatus";

type DetailedHourMeasurementProps = {
    value: MeasurementValue
}

function renderValue(value: any) {
    if (value == null) return '—';
    if (typeof value === 'number') value = value.toFixed(1);
    return value;
}

export function HourMeasurementDetailsItem({ value: { displayName, typeCode, unit, value } }: DetailedHourMeasurementProps) {

    let iconSrc = null;
    let iconRotateAngle = null;
    if (typeCode === "precipitation_type") {
        const weatherCondition = Object.values(WEATHER_CONDITIONS).find((wc) => wc?.code === value)
        iconSrc = weatherCondition?.iconSrc;
        value = weatherCondition?.caption;
    }
    if (typeCode === "wind_direction") {
        iconSrc = windDirectionIconSrc;
        iconRotateAngle = value;
        const windDirection = getWindDirectionByAngle(value)
        value = windDirection
    }
    if (typeCode === "road_status") {
        const roadStatus = Object.values(ROAD_STATUSES).find((rs) => rs?.code === value)
        value = roadStatus?.caption
    }

    return (
        <Col>
            <div className="hour-measurement-details-item-div">
                <div className="caption">{displayName}{unit ? `, ${unit}` : ''}</div>
                <div className="value">
                    {iconSrc &&
                        <img
                            src={iconSrc}
                            style={{
                                transform: iconRotateAngle != null ? `rotate(${iconRotateAngle}deg)` : "none",
                                transition: "transform 0.3s ease",
                            }}
                        />}
                    {renderValue(value)}
                </div>
            </div>
        </Col>
    )
}
